import React from 'react';

interface BigValueLogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const BigValueLogo: React.FC<BigValueLogoProps> = ({
  className = "",
  width = 24,
  height = 24
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_836_1566)">
        <path
          d="M14.3266 9.6733H10.3847C8.6043 9.6733 7.15863 11.119 7.15863 12.8993V16.8412H3.22603C1.44567 16.8412 0 15.3956 0 13.6152V5.7314C0 3.95104 1.44567 2.50537 3.22603 2.50537H7.16793C11.1238 2.50537 14.3312 5.71281 14.3312 9.66865L14.3266 9.6733Z"
          fill="#00E49B"
        />
        <path
          d="M14.3261 9.67334V13.6152C14.3261 15.3956 12.8851 16.8413 11.1001 16.8413H7.1582V12.8994C7.1582 11.119 8.60387 9.67334 10.3842 9.67334H14.3261Z"
          fill="#4434E2"
        />
        <path
          d="M21.4943 16.8369V20.7788C21.4943 22.5591 20.0533 24.0048 18.2683 24.0048H10.3891C8.60876 24.0048 7.16309 22.5591 7.16309 20.7788V16.8369H11.105C12.8853 16.8369 14.331 15.3912 14.331 13.6108V9.66895C18.2869 9.66895 21.4943 12.8764 21.4943 16.8322V16.8369Z"
          fill="#9E5DF9"
        />
        <path
          d="M2.14759 23.9998C3.33367 23.9998 4.29518 23.0383 4.29518 21.8522C4.29518 20.6661 3.33367 19.7046 2.14759 19.7046C0.961508 19.7046 0 20.6661 0 21.8522C0 23.0383 0.961508 23.9998 2.14759 23.9998Z"
          fill="#4434E2"
        />
        <path
          d="M20.2391 7.52121C22.316 7.52121 23.9997 5.83753 23.9997 3.7606C23.9997 1.68368 22.316 0 20.2391 0C18.1622 0 16.4785 1.68368 16.4785 3.7606C16.4785 5.83753 18.1622 7.52121 20.2391 7.52121Z"
          fill="#4434E2"
        />
      </g>
      <defs>
        <clipPath id="clip0_836_1566">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default BigValueLogo;
